import { render, staticRenderFns } from "./PopularCategories.vue?vue&type=template&id=485966b5&scoped=true&"
import script from "./PopularCategories.vue?vue&type=script&lang=ts&"
export * from "./PopularCategories.vue?vue&type=script&lang=ts&"
import style0 from "./PopularCategories.vue?vue&type=style&index=0&id=485966b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485966b5",
  null
  
)

export default component.exports